export default __webpack_public_path__ + "static/media/home3.7769d2f2.jpg";